import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class NCDSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getNCDSearch(data);
    }
}
export default NCDSearchUseCase;
